// leadsAnalytics.js — Item 8 (product telemetry expansion) — Leads workflow
//
// Thin, declarative wrappers over lib/analytics.track for the Leads pipeline.
// Centralizing the event names here keeps call sites clean and locks the
// contract under test. track() already injects the BL-025 `environment` tag.
//
// PII-safe (ADR-040): status/entry enums only — never a lead address, contact,
// name, or free-text note.

import { track } from './analytics';

export function leadCreated({ entry_type } = {}) {
  track('lead_created', { entry_type });
}

// The pipeline funnel signal (Metric M-005): a lead's movement between statuses.
export function leadStatusChanged({ from_status, to_status } = {}) {
  track('lead_status_changed', { from_status, to_status });
}

export function leadDeleted({ status } = {}) {
  track('lead_deleted', { status });
}

// Pipeline → Deal Analyzer handoff.
export function leadToDealAnalyzer({ status } = {}) {
  track('lead_to_deal_analyzer', { status });
}
